import { render, staticRenderFns } from "./ComentariosOcorrencia.vue?vue&type=template&id=860620fa&"
import script from "./ComentariosOcorrencia.vue?vue&type=script&lang=js&"
export * from "./ComentariosOcorrencia.vue?vue&type=script&lang=js&"
import style0 from "./ComentariosOcorrencia.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports